import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";
import { debounce } from "lodash-es";
var namespaceSetting = {
  name: "".concat(process.env.APP_NAME, "_").concat(process.env.APP_VERSION, "_PaneCacheStore")
};
var initialState = {
  scrollHistory: {},
  setScrollHistory: function setScrollHistory() {},
  clearScrollHistory: function clearScrollHistory() {}
};
var handleSetScrollHistory = function handleSetScrollHistory(scrollRecords, get, set) {
  var newHistory = _objectSpread({}, get().scrollHistory);
  scrollRecords.forEach(function (r) {
    newHistory[r.pathname] = r.value;
  });
  set({
    scrollHistory: newHistory
  });
};
var debounceSetScrollHistory = debounce(function (scrollRecords, get, set) {
  handleSetScrollHistory(scrollRecords, get, set);
}, 600);

// create the store
export var usePaneCacheStore = createWithEqualityFn()(devtools(persist(function (set, get) {
  return _objectSpread(_objectSpread({}, initialState), {}, {
    setScrollHistory: function setScrollHistory(scrollRecords) {
      var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (immediate) {
        handleSetScrollHistory(scrollRecords, get, set);
      } else {
        debounceSetScrollHistory(scrollRecords, get, set);
      }
    },
    clearScrollHistory: function clearScrollHistory() {
      set({
        scrollHistory: {}
      });
    }
  });
}, _objectSpread(_objectSpread({}, namespaceSetting), {}, {
  storage: createJSONStorage(function () {
    return sessionStorage;
  })
})), namespaceSetting), shallow);